import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
	UrlTree,
} from '@angular/router';
import { SessionService } from '@app/services/session.service';

@Injectable()
export class IsNotLoggedGuard implements CanActivate {
	constructor(
		private _sessionService: SessionService,
		private _router: Router
	) {}

	async canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<UrlTree | boolean> {
		if (await this._sessionService.loggedIn()) {
			return this._router.createUrlTree(['/dashboard']);
		} else {
			return true;
		}
	}
}
